/**
 * @link https://span.studio
 * @copyright Copyright (c) Span Studio LLC
 * @license https://github.com/Span-Studio/sta100-craft5/blob/main/LICENSE.md
 * 
 * Entry Credits.
 * UI for adding individual credits for contributions to an entry. 
 * 
 * @author John Pobojewski <https://john.pobojewski.com>
 */

import Sortable from 'sortablejs';

class EntryCredits {
	constructor() {
		this.cnt = 1;
	}

	init() {
		console.log("EntryCredits: init()");

		document.querySelectorAll("button[data-action=add-credit]").forEach(btn => {
			btn.addEventListener("click", () => {
				this.createRow(this.cnt);
				this.reorderRows();
				this.cnt++;
				document.querySelectorAll("input[type=submit]").forEach(submit => {
					submit.classList.remove("hidden");
				});
			});
		});

		document.querySelectorAll("span.delete").forEach(btn => {
			btn.addEventListener("click", () => {
				const index = btn.getAttribute("data-index");
				this.deleteRow(index);
			});
		});

		this.reorderRows();
	}

	createRow(cnt, setRole = "", setName = "") {
		console.log("EntryCredits.createRow(): " + cnt);

		const figure = document.createElement("figure");
		figure.className = "credit-row ui-state-default";
		figure.setAttribute("data-index", cnt);

		figure.innerHTML = `
			<span class="drag-handle">Drag to reorder</span>
			<input type="hidden" name="fields[credits][new${cnt}][type]" value="individual">
			<input type="text" id="name${cnt}" name="fields[credits][new${cnt}][fields][fullName]" value="${setName}" placeholder="Name">
			<input type="text" id="role${cnt}" name="fields[credits][new${cnt}][fields][role]" value="${setRole}" placeholder="Role">
		`;

		const deleteBtn = document.createElement("span");
		deleteBtn.className = "delete";
		deleteBtn.setAttribute("data-index", cnt);
		deleteBtn.textContent = "Delete row";
		deleteBtn.addEventListener("click", () => {
			this.deleteRow(cnt);
		});
		figure.appendChild(deleteBtn);

		document.getElementById("credits").appendChild(figure);
	}

	deleteRow(index) {
		console.log("EntryCredits.deleteRow(): " + parseInt(index));

		const figure = document.querySelector(`figure[data-index="${index}"]`);
		if (!figure) return;

		const deleteButton = figure.querySelector("span.delete");
		if (deleteButton) {
			const loader = document.createElement("span");
			loader.className = "spinner";
			loader.innerHTML = "<span>Deleting...</span>";
			deleteButton.replaceWith(loader);
		}

		figure.style.transition = "opacity 0.5s ease";
		figure.style.opacity = 0;
		setTimeout(() => {
			figure.remove();

			if (document.querySelectorAll(".credit-row").length === 0) {
				document.querySelectorAll("input[type=submit]").forEach(submit => {
					submit.classList.add("hidden");
				});
			}
		}, 500);
	}

	reorderRows() {
		const creditsContainer = document.getElementById("credits");

		Sortable.create(creditsContainer, {
			handle: ".drag-handle",
			animation: 150,
			onEnd: () => {

				const figures = creditsContainer.querySelectorAll("figure");
				figures.forEach((figure, index) => {
					//console.log(figure.getAttribute("data-index"), index);
					figure.setAttribute("data-index", index);

					figure.querySelectorAll("input").forEach(input => {
						if (input.name) {
							input.name = input.name.replace(/\d+/g, index);
						}
						if (input.id) {
							input.id = input.id.replace(/\d+/g, index);
						}
					});

					figure.querySelectorAll("label").forEach(label => {
						if (label.htmlFor) {
							label.htmlFor = label.htmlFor.replace(/\d+/g, index);
						}
					});

					const delBtn = figure.querySelector(".delete");
					if (delBtn) {
						delBtn.setAttribute("data-index", index);
						delBtn.onclick = () => this.deleteRow(index);
					}
				});
			}
		});
	}
}

export default new EntryCredits();
